import { Project } from "../../types/Project";
import { ProjectAction, ProjectActionType } from "../actions/projectAction";

const initialState: Project[] = [];

const projectReducer = (
  state = initialState,
  action: ProjectAction,
): Project[] => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECTS:
      return action.data;

    case ProjectActionType.ADD_PROJECT:
      return [...state, action.data];

    case ProjectActionType.EDIT_PROJECT:
      return state.map((proj) =>
        proj.id === action.data.id ? action.data : proj,
      );

    case ProjectActionType.DELETE_PROJECT:
      return state.filter((proj) => proj.id !== action.data);

    default:
      return state;
  }
};

export default projectReducer;
